module.exports = {
      id: "image-usage",
      viewBox: "0 0 27 27",
      url: __webpack_public_path__ + "svg-sprite-9bf32fda02e4f885c0073d291388af8d.svg#image",
      toString: function () {
        return this.url;
      }
    }